import { mapObject } from 'underscore';
export const translateErrors = (response, t) => mapObject(response, values => values.map(v => t(`error:${v}`)));
